import React, { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import api from '../../utils/api';
import { Button } from '../ui/button';
import { when } from './holidayWorldContacts';

export const HolidayWorldOverdueBanner = ({ eventId, count, refresh, active, onShowAll, onClear, onAssign }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let live = true;
    if (!count) { setRows([]); return undefined; }
    api.get(`/admin/home-smart-events/${eventId}/contacts`, { params: { overdue: true, sort: 'assigned_at', order: 'asc', limit: 5 } })
      .then(({ data }) => { if (live) setRows(data.items); }).catch(() => { if (live) setRows([]); });
    return () => { live = false; };
  }, [eventId, count, refresh]);
  if (!count && !active) return null;
  return <section role="status" className="space-y-3 rounded-md border border-red-200 bg-red-50 p-4" data-testid={`hw-overdue-banner-${eventId}`}>
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="flex items-center gap-2 font-semibold text-red-900" data-testid={`hw-overdue-count-${eventId}`}><AlertTriangle className="h-4 w-4" />{count === 1 ? '1 contatto senza risposta' : `${count} contatti senza risposta`} da oltre 48 ore dal promemoria</p>
      {active ? <Button size="sm" variant="outline" onClick={onClear} data-testid={`hw-overdue-clear-${eventId}`}><X className="mr-1 h-4 w-4" />Mostra tutte le richieste</Button>
        : <Button size="sm" className="bg-red-700 text-white hover:bg-red-800" onClick={onShowAll} data-testid={`hw-overdue-show-${eventId}`}>Mostra solo questi</Button>}
    </div>
    {!active && rows.length > 0 && <ul className="divide-y divide-red-100" data-testid={`hw-overdue-list-${eventId}`}>{rows.map(row => <li key={row.id} className="flex flex-wrap items-center justify-between gap-2 py-2 text-sm" data-testid={`hw-overdue-item-${row.id}`}>
      <span className="min-w-0 break-words"><strong>{row.first_name} {row.last_name}</strong> · {row.assignment?.assignee_name} · promemoria del {when(row.assignment?.awaiting_since)}</span>
      <Button size="sm" variant="outline" onClick={() => onAssign(row)} data-testid={`hw-overdue-reassign-${row.id}`}>Riassegna</Button>
    </li>)}</ul>}
  </section>;
};
